import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'

// Routes
import adminRoutes from './admin.routes'
import publicRoutes from './public.routes'
import surveyRoutes from './survey.routes'
import labsRoutes from './labs.routes'

// Store
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  ...publicRoutes,
  ...adminRoutes,
  ...surveyRoutes,
  ...labsRoutes,
  {
    path: '*',
    name: 'page-not-found',
    component: () => import(/* webpackChunkName: "group-public" */ '@/views/errors/PageNotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuthenticated']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
